import React, { useEffect } from 'react';
import './LandingPage.css';
import './landing/ScrollFixes.css';
import Header from './landing/Header';
import HeroSection from './landing/HeroSection';
import AboutSection from './landing/AboutSection';
import ContactSection from './landing/ContactSection';
import Footer from './landing/Footer';
import ChatWidget from './landing/ChatWidget';
import ScrollableContainer from './landing/ScrollableContainer';

function LandingPage() {
  // More aggressive document structure forcing for scrolling
  useEffect(() => {
    // Force scrollbar display with important styles - only on html
    document.documentElement.style.cssText = `
      overflow-y: auto !important;
      overflow-x: hidden !important;
      height: auto !important;
      min-height: 100% !important;
      max-height: none !important;
      position: static !important;
      display: block !important;
    `;
    
    // Reset body styling completely with important flags - no scroll here
    document.body.style.cssText = `
      margin: 0 !important;
      padding: 0 !important;
      height: auto !important;
      min-height: 100% !important;
      display: block !important;
      overflow: hidden !important;
      position: static !important;
      background: #fff !important;
      max-height: none !important;
      width: 100% !important;
    `;
    
    document.body.classList.add('landing-page-body');
    
    // Create a style element to force scrolling only on html
    const styleEl = document.createElement('style');
    styleEl.id = 'landing-page-scroll-fix';
    styleEl.innerHTML = `
      html {
        overflow-y: auto !important;
        overflow-x: hidden !important;
        max-height: none !important;
        height: auto !important;
        min-height: 100% !important;
        position: static !important;
        display: block !important;
        width: 100% !important;
      }
      body {
        overflow: hidden !important;
        max-height: none !important;
        height: auto !important;
        min-height: 100% !important;
        position: static !important;
        display: block !important;
        width: 100% !important;
      }
      #root {
        min-height: 100% !important;
        height: auto !important;
        overflow: hidden !important;
        position: static !important;
        display: block !important;
        width: 100% !important;
      }
      .footer {
        position: relative !important;
        bottom: 0 !important;
        width: 100% !important;
        max-width: 100% !important;
      }
      
      /* Remove all additional scrollbars */
      .scrollable-container, #landing-page-container, main, section {
        overflow: hidden !important;
      }
      
      /* Explicitly hide any scrollbars in header */
      .header, .header-content, .nav-menu {
        overflow: hidden !important;
        overflow-y: hidden !important;
        overflow-x: hidden !important;
      }
    `;
    document.head.appendChild(styleEl);
    
    return () => {
      document.documentElement.style.cssText = '';
      document.body.style.cssText = '';
      document.body.classList.remove('landing-page-body');
      const styleElement = document.getElementById('landing-page-scroll-fix');
      if (styleElement) {
        styleElement.remove();
      }
    };
  }, []);

  // Get viewport height for container minimum height
  const minHeight = typeof window !== 'undefined' ? `${window.innerHeight}px` : '100vh';

  // Use more specific inline styles to guarantee layout behavior
  return (
    <ScrollableContainer>
      <div id="landing-page-container" style={{
        width: '100%',
        minHeight,
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden', // Changed from hidden to ensure no scrollbar
        paddingBottom: '0',
        marginTop: '0',
        marginBottom: '0'
      }}>
        <Header />
        <main style={{
          width: '100%',
          overflow: 'hidden', // Changed from hidden to ensure no scrollbar
          display: 'block',
          position: 'relative',
          minHeight: 'auto',
          flex: '1 0 auto'
        }}>
          <HeroSection />
          <AboutSection />
          <ContactSection />
        </main>
        <Footer />
        <ChatWidget />
      </div>
    </ScrollableContainer>
  );
}

export default LandingPage;